/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { firstReleasedCompany, keepAllSelected } from 'services/selected_companies';
import { ProfileTypes, ProfileState } from './types';

const INITIAL_STATE: ProfileState = {
  profile: {
    id: 0,
    clientId: 0,
    ddd_cellphone: '',
    cellphone: '',
    cpf: '',
    cnpj: '',
    name: '',
    email: '',
    permissions: [],
    isSigned: false,
    in_sample: false,
    in_analysis: false,
    alfa_tester: false,
    modal: true,
    can_use_my_documents: false,
    has_documents_company: false,
    can_use_conlicitaseg: false,
    is_only_conlicitaseg: false,
    fidelize: {
      is_fidelize: false,
      biddings: [],
    },
    beta_tester: false,
    ambassador: {
      invited: false,
      member: false,
      subscriber: false,
      tools: [],
    },
    robo_access: false,
    sale_situation: '',
    conlicitantes_vip_banner: false,
    responsible: '',
    enable_captcha: false,
    partner_user: false,
    paralyzed: false,
    first_bulletin_unread: false,
    representant: false,
    represented: [],
    currentCompany: {},
    selectedCompanies: {},
    company_data: {
      data: {
        id: 0,
        cnpj: '',
        razao_social: '',
        nome_fantasia: '',
        inscricao_estadual: '',
        ddd_telefone: '',
        numero_telefone: '',
        email: '',
        website: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cep: '',
        estado_id: 0,
      },
      estado: '',
      cidade: '',
    },
    consultant_login: false,
    loginStatus: {
      text: '',
      class: '',
      show: false,
    },
    password_message: '',
    resource_name: '',
    resource_email: '',
    message_success_password: '',
    can_use_dr_licita: false,
    dr_licita_atendimento: false,
    validate_services: {
      gerenciar_documentos: true,
      monitorar_chat: true,
      assinatura_digital: false,
      robo: false,
      conlicitago: true,
      course_iaml: false,
      dr_licita: false,
    },
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
  refresh_request: {
    loading: false,
    loaded: false,
    error: false,
  },
  register_request: {
    loading: false,
    loaded: false,
    error: false,
  },
  password_new: {
    loading: false,
    loaded: false,
    error: false,
  },
  password_edit: {
    loading: false,
    loaded: false,
    error: false,
  },
  password_update: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<ProfileState> = (
  state = INITIAL_STATE,
  { type, result, rest, companyId, companyIds, tabId, modal, avatar_url },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case ProfileTypes.SHOW_REQUEST:
        draft.profile = INITIAL_STATE.profile;
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProfileTypes.SHOW_SUCCESS:
        if (!result) return;
        draft.profile.email = result.data.user.email;
        draft.profile.name = result.data.user.name;
        draft.profile.contact_name = result.data.user.contact_name;
        draft.profile.admin = !!result.data.user.admin;
        draft.profile.id = result.data.user.id;
        draft.profile.clientId = result.data.user.client_id;
        draft.profile.ddd_cellphone = result.data.user.ddd_cellphone;
        draft.profile.cellphone = result.data.user.cellphone;
        draft.profile.cpf = result.data.user.cpf;
        draft.profile.cnpj = result.data.user.cnpj;
        draft.profile.permissions = result.data.services.available;
        draft.profile.isSigned = true;
        draft.profile.in_sample = result.data.user.in_sample;
        draft.profile.in_analysis = result.data.user.in_analysis;
        draft.profile.alfa_tester = result.data.user.alfa_tester;
        draft.profile.beta_tester = result.data.user.beta_tester;
        draft.profile.ambassador = result.data.user.ambassador || INITIAL_STATE.profile.ambassador;
        draft.profile.can_use_my_documents = result.data.user.can_use_my_documents;
        draft.profile.can_use_dr_licita = result.data.user.can_use_dr_licita;
        draft.profile.dr_licita_atendimento = !!result.data.user.dr_licita_atendimento;
        draft.profile.can_use_conlicitaseg = result.data.user.can_use_conlicitaseg;
        draft.profile.is_only_conlicitaseg = !!result.data.user.is_only_conlicitaseg;
        draft.profile.fidelize = result.data.user.fidelize;
        draft.profile.has_documents_company = result.data.user.has_documents_company;
        draft.profile.robo_access = result.data.user.robo_access;
        draft.profile.sale_situation = result.data.user.sale_situation;
        draft.profile.conlicitantes_vip_banner = result.data.user.conlicitantes_vip_banner;
        draft.profile.responsible = result.data.user.responsible;
        draft.profile.enable_captcha = result.data.user.enable_captcha;
        draft.profile.partner_user = result.data.user.partner_user;
        draft.profile.paralyzed = result.data.user.paralyzed;
        draft.profile.first_bulletin_unread = result.data.user.first_bulletin_unread;
        draft.profile.company_data = result.data.company_data;
        draft.profile.consultant_login = result.data.user.consultant_login;
        draft.profile.representant = result.data.user.representant;
        draft.profile.represented = result.data.user.represented;
        draft.profile.validate_services.gerenciar_documentos =
          result?.data?.user?.validate_services?.gerenciar_documentos;
        draft.profile.validate_services.monitorar_chat =
          result?.data?.user?.validate_services?.monitorar_chat;
        draft.profile.validate_services.assinatura_digital =
          result?.data?.user?.validate_services?.assinatura_digital;
        draft.profile.validate_services.robo = result?.data?.user?.validate_services?.robo;
        draft.profile.validate_services.conlicitago =
          result?.data?.user?.validate_services?.conlicitago;
        draft.profile.validate_services.course_iaml =
          result?.data?.user?.validate_services?.course_iaml;
        draft.profile.validate_services.dr_licita =
          result?.data?.user?.validate_services?.dr_licita;
        if (tabId && !result.data.user.alfa_tester) {
          draft.profile.currentCompany = {
            ...state.profile.currentCompany,
            [tabId]:
              result.data.user.represented && result.data.user.represented.length > 0
                ? result.data.user.represented[0].id
                : result.data.user.client_id,
          };
        } else if (tabId) {
          draft.profile.currentCompany = {
            ...state.profile.currentCompany,
            [tabId]: result.data.user.client_id,
          };
          draft.profile.selectedCompanies = {
            ...state.profile.selectedCompanies,
            [tabId]: [],
          };
        }

        if (!rest) draft.profile.loginStatus.show = false;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };

        break;
      case ProfileTypes.SHOW_FAILURE:
        draft.profile = INITIAL_STATE.profile;

        if (!rest)
          draft.profile.loginStatus = {
            text: 'Usuário ou senha inválidos',
            class: 'danger',
            show: true,
          };

        if (rest)
          draft.profile.loginStatus = {
            text: '',
            class: '',
            show: false,
          };

        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProfileTypes.LOGOUT_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProfileTypes.LOGOUT_SUCCESS:
        draft.profile = INITIAL_STATE.profile;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProfileTypes.LOGOUT_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProfileTypes.REFRESH_PROFILE_SUCCESS:
        if (!result) {
          draft.refresh_request = {
            loading: false,
            loaded: false,
            error: true,
          };
          draft.profile.isSigned = false;
          return;
        }

        draft.profile.email = result.data.user.email;
        draft.profile.name = result.data.user.name;
        draft.profile.contact_name = result.data.user.contact_name;
        draft.profile.admin = !!result.data.user.admin;
        draft.profile.id = result.data.user.id;
        draft.profile.clientId = result.data.user.client_id;
        draft.profile.ddd_cellphone = result.data.user.ddd_cellphone;
        draft.profile.cellphone = result.data.user.cellphone;
        draft.profile.cpf = result.data.user.cpf;
        draft.profile.cnpj = result.data.user.cnpj;
        draft.profile.permissions = result.data.services.available;
        draft.profile.in_sample = result.data.user.in_sample;
        draft.profile.in_analysis = result.data.user.in_analysis;
        draft.profile.alfa_tester = result.data.user.alfa_tester;
        draft.profile.beta_tester = result.data.user.beta_tester;
        draft.profile.ambassador = result.data.user.ambassador || INITIAL_STATE.profile.ambassador;
        draft.profile.can_use_my_documents = result.data.user.can_use_my_documents;
        draft.profile.can_use_dr_licita = result.data.user.can_use_dr_licita;
        draft.profile.dr_licita_atendimento = !!result.data.user.dr_licita_atendimento;
        draft.profile.can_use_conlicitaseg = result.data.user.can_use_conlicitaseg;
        draft.profile.is_only_conlicitaseg = !!result.data.user.is_only_conlicitaseg;
        draft.profile.fidelize = result.data.user.fidelize;
        draft.profile.has_documents_company = result.data.user.has_documents_company;
        draft.profile.robo_access = result.data.user.robo_access;
        draft.profile.sale_situation = result.data.user.sale_situation;
        draft.profile.conlicitantes_vip_banner = result.data.user.conlicitantes_vip_banner;
        draft.profile.responsible = result.data.user.responsible;
        draft.profile.enable_captcha = result.data.user.enable_captcha;
        draft.profile.partner_user = result.data.user.partner_user;
        draft.profile.paralyzed = result.data.user.paralyzed;
        draft.profile.first_bulletin_unread = result.data.user.first_bulletin_unread;
        draft.profile.consultant_login = result.data.user.consultant_login;
        draft.profile.representant = result.data.user.representant;
        draft.profile.selectedCompanies = keepAllSelected(
          state.profile.selectedCompanies,
          state.profile.represented,
          result.data.user.represented,
          result.data.user.client_id,
        );
        draft.profile.represented = result.data.user.represented;
        draft.profile.validate_services.gerenciar_documentos =
          result?.data?.validate_services?.gerenciar_documentos;
        draft.profile.validate_services.monitorar_chat =
          result?.data?.validate_services?.monitorar_chat;
        draft.profile.validate_services.assinatura_digital =
          result?.data?.validate_services?.assinatura_digital;
        draft.profile.validate_services.robo = result?.data?.validate_services?.robo;
        draft.profile.validate_services.conlicitago = result?.data?.validate_services?.conlicitago;
        draft.profile.validate_services.course_iaml = result?.data?.validate_services?.course_iaml;
        draft.profile.validate_services.dr_licita = result?.data?.validate_services?.dr_licita;

        if (tabId) {
          draft.profile.currentCompany = {
            ...state.profile.currentCompany,
            [tabId]: result.data.user.client_id,
          };
          draft.profile.selectedCompanies = {
            ...state.profile.selectedCompanies,
            [tabId]: [],
          };
        }

        draft.refresh_request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;

      case ProfileTypes.REFRESH_PROFILE_REQUEST:
        draft.refresh_request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProfileTypes.REFRESH_PROFILE_FAILURE:
        draft.profile = INITIAL_STATE.profile;
        draft.refresh_request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ProfileTypes.UPDATE_STORE_FIELDS:
        if (!state.refresh_request) draft.refresh_request = INITIAL_STATE.refresh_request;
        if (!state.profile.paralyzed) draft.profile.paralyzed = INITIAL_STATE.profile.paralyzed;
        if (!state.profile.currentCompany)
          draft.profile.currentCompany = INITIAL_STATE.profile.currentCompany;
        if (!state.profile.selectedCompanies)
          draft.profile.selectedCompanies = INITIAL_STATE.profile.selectedCompanies;
        if (!state.profile.representant)
          draft.profile.representant = INITIAL_STATE.profile.representant;
        if (!state.profile.represented)
          draft.profile.represented = INITIAL_STATE.profile.represented;
        if (!state.profile.ambassador) draft.profile.ambassador = INITIAL_STATE.profile.ambassador;

        break;
      case ProfileTypes.SET_AVATAR_URL:
        draft.profile.avatar_url = avatar_url;
        break;
      case ProfileTypes.REGISTER_REQUEST:
        draft.register_request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProfileTypes.REGISTER_SUCCESS:
        draft.register_request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProfileTypes.REGISTER_FAILURE:
        draft.register_request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProfileTypes.PASSWORD_NEW_REQUEST:
        draft.profile.password_message = INITIAL_STATE.profile.password_message;

        draft.password_new = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProfileTypes.PASSWORD_NEW_SUCCESS:
        draft.profile.password_message = result?.data?.message;
        draft.password_new = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProfileTypes.PASSWORD_NEW_FAILURE:
        draft.profile.password_message = result?.data?.message;
        draft.password_new = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ProfileTypes.PASSWORD_EDIT_REQUEST:
        draft.profile.resource_email = INITIAL_STATE.profile.resource_name;
        draft.password_edit = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProfileTypes.PASSWORD_EDIT_SUCCESS:
        draft.profile.resource_email = result?.data?.email;
        draft.password_edit = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProfileTypes.PASSWORD_EDIT_FAILURE:
        draft.profile.resource_email = result?.data?.error;
        draft.password_edit = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ProfileTypes.PASSWORD_UPDATE_REQUEST:
        draft.password_update = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProfileTypes.PASSWORD_UPDATE_SUCCESS:
        draft.profile.message_success_password = result?.data?.message;
        draft.password_update = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProfileTypes.PASSWORD_UPDATE_FAILURE:
        draft.profile.message_success_password = result?.data?.errors[0];
        draft.password_update = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ProfileTypes.INVITATION_REQUEST:
        draft.password_update = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProfileTypes.INVITATION_SUCCESS:
        draft.profile.resource_name = result?.data?.resource_name;
        draft.profile.resource_email = result?.data?.email;
        draft.profile.message_success_password = result?.data?.message;
        draft.password_update = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProfileTypes.INVITATION_FAILURE:
        draft.profile.message_success_password = result?.data?.message;
        draft.password_update = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ProfileTypes.INVITATION_UPDATE_REQUEST:
        draft.profile = INITIAL_STATE.profile;
        draft.password_update = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ProfileTypes.INVITATION_UPDATE_SUCCESS:
        draft.profile.message_success_password = result?.data?.message;
        draft.password_update = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ProfileTypes.INVITATION_UPDATE_FAILURE:
        draft.password_update = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case ProfileTypes.UPDATE_CURRENT_COMPANY: {
        draft.profile.currentCompany[tabId] = companyId;
        const selected = state.profile.selectedCompanies?.[tabId] || [];
        const own = companyId === state.profile.clientId;
        const covered = selected.includes(companyId) || (own && selected.length === 0);
        if (state.profile.representant && !covered) {
          draft.profile.selectedCompanies = {
            ...state.profile.selectedCompanies,
            [tabId]: own ? [] : [companyId],
          };
        }
        break;
      }
      case ProfileTypes.UPDATE_SELECTED_COMPANIES: {
        draft.profile.currentCompany[tabId] =
          firstReleasedCompany(state.profile, companyIds) ?? state.profile.clientId;
        draft.profile.selectedCompanies = {
          ...state.profile.selectedCompanies,
          [tabId]: companyIds,
        };
        break;
      }
      case ProfileTypes.VIEW_MODAL:
        draft.profile.modal = modal;
        break;

      default:
        break;
    }
  });
};

export default reducer;
